import type { Transaction } from './types';

// The single place that decides where a "contact support" action leads: the merchant's support
// address when the deposit has one, otherwise the redirect address, as before it existed.
export const supportTarget = (transaction: Pick<Transaction, 'supportUrl' | 'redirectUrl'>): string =>
  transaction.supportUrl || transaction.redirectUrl;
